import{useContext as e}from"react";import t from"../../contexts/ThemeVersionContext/ThemeVersionContext.js";const o=()=>e(t);export{o as default};
//# sourceMappingURL=useThemeVersion.js.map
